import $ from 'jquery';

export const initAccordion = function(el) {

	var mode = el.data('accordion') || 'single';

	el.on('close.accordion',function() {
		el.find('[data-accordion-item].active').trigger('close.accordion');
	});

	el.find('[data-accordion-title],[data-accordion-trigger]').click(function(event) {
		event.stopPropagation();
		var item = $(this).closest('[data-accordion-item]');
		if(item.hasClass('active')) {
			item.trigger('close.accordion');
		} else {
			item.trigger('open.accordion');
			if(mode == 'single') {
				item.siblings().filter('.active').trigger('close.accordion');
			}
		}
	});

	el.find('[data-accordion-item]').on('open.accordion close.accordion',function(event) {
		event.stopPropagation();
		if(event.namespace!='accordion') {
			return;
		}
		var item = $(this);
		var content = item.find('[data-accordion-content]');
		if(event.type == 'close') {
			item.removeClass('active');
			content.slideUp();
		} else {
			item.addClass('active');
			content.slideDown();
		}

	});
}

export default {

	init: function() {
		$('[data-accordion]').each( function() {
			initAccordion( $(this) );
		} );
	},

}
